import _ from 'lodash';

export const getFieldValue = (element, fieldName) => {
    const field = element.fieldsByName[fieldName];
    if (field != null) {
        if (field.parts != null) {
            // is this a sensible thing to call the 'value' of a
            // non-primitive field?
            return field.parts;
        }
        return field.value;
    }
};

export const getFields = (element, ...fields) => {
    const fieldsArray = Array.from(fields);
    return _.reduce(fieldsArray, (acc, field) => {
        acc[field] = getFieldValue(element, field);
        return acc;
    }, {});
};

// find all elements whose componentNames match the given elementPattern on pages matching the given pagePattern
export const findElements = (lesson, pagePattern, elementPattern) => {
    const pagePat = new RegExp(pagePattern, 'i');
    const pages = Object.values(lesson.nodeMap).filter(node => node.nodeClass === 'page' && node.componentName.match(pagePat));
    const elements = [];
    const elPat = new RegExp(elementPattern, 'i');
    const findElements = (n) => {
        if (n.nodeClass === 'element' && n.componentName.match(elPat)) {
            elements.push(n);
        }  else if (n.children && n.children.length > 0) {
            n.children.forEach(c => findElements(c));
        }
    }
    pages.forEach(p => findElements(p));
    return elements;
};